<form class="itinerary-model-content-inner"  [formGroup]="accessForm" *ngIf="accessForm">
  <div class="itinerary-model-content">
    <div class="form-container">
      <!-- Users Details start -->
      <div class="ion-no-padding">
        <ion-title class="dark-title-sm ion-padding-horizontal py-1 bg-light-gray">Enable/Disable Modules</ion-title>
      </div>

      <div class="ion-padding-horizontal">
        <div class="table-container">
          <table>
            <thead class="thead-dark">
              <tr>
                <th style="width: 80px;">Module Name</th>
                <th style="width: 50px;">Access</th>
                <th style="width: 80px;">Start Date</th>
                <th style="width: 80px;">End Date</th>
              </tr>
            </thead>
        
            <tbody formArrayName="modules">
              <tr *ngFor="let module of getModuleArray().controls; let i = index" [formGroupName]="i">
                <td class="module-name">{{module.get('name')?.value}}</td>
                <td><ion-toggle class="access-toggle-btn" formControlName="access"></ion-toggle></td>
                <td>{{ module.get('startDate')?.value ? (module.get('startDate')?.value | date: 'dd/MM/yyyy') : '--' }}</td>
                <td>{{ module.get('endDate')?.value ? (module.get('endDate')?.value | date: 'dd/MM/yyyy') : '--' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      
      
      <!-- Users details end -->

    </div>
    

  </div>
  
  <div class="ion-padding-horizontal bg-light-gray justify-content-center itinerary-model-footer">
    <ion-button class="unfilled-blue-btn" (click)="goPrevious()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-back-outline"></ion-icon>
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="resetForm()" [disabled]="!formDataModified()">
      Reset
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="onSubmit()" [disabled]="!formDataModified()">
      Save
    </ion-button>
    <ion-button class="filled-blue-btn" (click)="saveAndNext()" [disabled]="!formDataModified()">
      Save & Next
    </ion-button>
    <ion-button class="unfilled-blue-btn" (click)="goNext()" [disabled]="formDataModified()">
      <ion-icon slot="icon-only" name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</form>


